import Button from "./ds/Button";
import Icon from "./ds/Icon";
import ProgressBar from "./ds/ProgressBar";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getMyProfile } from "../api/profile";

const CompleteSetupBanner = ({ user, isDark }) => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [profileData, setProfileData] = useState(null);

  // Fetch full profile data to check completion
  useEffect(() => {
    const fetchProfile = async () => {
      if (!user) return;
      
      try {
        const response = await getMyProfile();
        if (response.success) {
          setProfileData({
            ...response.user,
            ...response.profile,
          });
        }
      } catch (error) {
        console.error("Failed to load profile for banner:", error);
      }
    };

    fetchProfile();
  }, [user]);

  // Calculate profile completion percentage
  useEffect(() => {
    if (!user || !profileData) return;

    let completedFields = 0;
    let totalFields = 0;

    if (user.accountType === "creator") {
      totalFields = 4; // username, email, firstName, lastName (phone not stored in DB)
      if (user.username) completedFields++;
      if (user.email) completedFields++;
      if (profileData.firstName) completedFields++;
      if (profileData.lastName) completedFields++;
    } else if (user.accountType === "business") {
      totalFields = 3; // businessName, businessEmail, username (phone not stored in DB)
      if (user.username) completedFields++;
      if (profileData.businessEmail || user.email) completedFields++; // businessEmail or fallback to email
      if (profileData.businessName) completedFields++;
    }

    const percentage = totalFields > 0 ? Math.round((completedFields / totalFields) * 100) : 0;
    setProgress(percentage);
  }, [user, profileData]);

  // Check if profile is complete (100%)
  const isComplete = progress === 100;

  // Don't show if complete or no user
  if (isComplete || !user) return null;

  const handleCompleteSetup = () => {
    // Navigate to profile edit
    navigate("/profile?edit=true");
  };

  return (
    <div className="flex w-full items-center gap-space-12 rounded-radius-md bg-bg-raised p-space-12">
      <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-accent-tinted text-accent-tinted-label">
        <Icon name="check" size={16} />
      </span>
      <div className="flex min-w-0 flex-1 flex-col gap-[6px]">
        <div className="flex min-w-0 items-baseline gap-space-8">
          <h3 className="min-w-0 truncate text-footnote-semibold text-label-primary">Complete Your Profile</h3>
          <span className="shrink-0 text-caption-1 text-label-secondary">{progress}%</span>
        </div>
        <ProgressBar value={progress / 100} />
      </div>
      <Button size="s" variant="tinted" className="shrink-0" onClick={handleCompleteSetup}>
        Complete Setup
      </Button>
    </div>
  );
};

export default CompleteSetupBanner;

